var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.$style.icon,
    _vm.$style[_vm.color],
    _vm.isVisible ? _vm.$style.isVisible : ''
  ]},[_c('span',{class:_vm.$style.inner})])}
var staticRenderFns = []

export { render, staticRenderFns }